import { Type, Static } from '@sinclair/typebox';

// 🔔 Notification Message Schema - Real-time communication contract
// Simple notification fields for WebSocket messaging between server and frontend
export const NotificationMessageSchema = Type.Object(
  {
    id: Type.Number(),
    title: Type.String(),
    message: Type.String(),
    type: Type.Union([
      Type.Literal('info'),
      Type.Literal('success'),
      Type.Literal('warning'),
      Type.Literal('error'),
    ]),
    user_id: Type.Number(),
    is_read: Type.Boolean(),
    created_at: Type.String({ format: 'date-time' }),
    entity_url: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    payload: Type.Optional(Type.Union([Type.Any(), Type.Null()])),
  },
  { $id: 'NotificationMessage' }
);

// 🔔 TypeScript type automatically inferred from schema
export type NotificationMessage = Static<typeof NotificationMessageSchema>;
